import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/form-builder/")({
  beforeLoad: async () => {
    throw redirect({ to: "/form-builder/templates" });
  },
});
